import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MapComponent } from './map/map.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { GroupByPipe } from './group.pipe';

@NgModule({
  imports: [
    FlexLayoutModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatToolbarModule,
    MatIconModule,
    MatSnackBarModule,
    MatSelectModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    CommonModule,
  ],
  exports: [
    FlexLayoutModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatToolbarModule,
    MatIconModule,
    MatSnackBarModule,
    MatSelectModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    MatSidenavModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MapComponent,
    GroupByPipe
  ],
  declarations: [
    MapComponent,
    GroupByPipe
  ]
})
export class SharedModule { }
